import React, { useState } from "react";
// Assuming you have a logo image in the 'assets' folder or 'public' folder
import logo from "../../assets/images/le-logo.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState(false);
  const API_URI = process.env.REACT_APP_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      //  console.log("empty");
      setError("Email is required");
      return;
    }

    // Simple email format validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      // console.log("invalid email");
      setError("Please enter a valid email address");
      return;
    }

    try {
      setMsg(true);
      const response = await fetch(`${API_URI}forgot-password.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          email: email,
          type: "sendlink",
        }),
      });

      const data = await response.json();
      console.log(data);
      if (data.success) {
        setMsg(false);
        setMessage(data.message);
      } else {
        setMsg(false);
        setError(data.message);
      }
    } catch (err) {
      setMsg(false);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div
      className="content"
      style={{ backgroundColor: "#f8fafb", minHeight: "100vh" }}
    >
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="col-md-5">
          <div className="card shadow-lg border-0 rounded-lg">
            <div className="card-body">
              <div className="text-center mb-4">
                <img
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                  style={{ maxHeight: "60px" }}
                />
              </div>
              <h3 className="text-center mb-4">Forgot Password</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Email Address:</label>
                  <input
                    type="email"
                    id="email"
                    style={{
                      width: "100%",
                      padding: "8px",
                      marginBottom: "15px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                      fontSize: "14px",
                    }}
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <button
                    type="submit"
                    style={{
                      padding: "7px",
                      border: "none",
                      backgroundColor: "#007bff",
                      color: "#fff",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    Send Reset Link
                  </button>
                  {msg ? (
                    <span style={{ color: "#f9b108", marginLeft: "10px" }}>
                      sending...
                    </span>
                  ) : null}
                </div>
              </form>

              {message && (
                <div className="alert alert-success mt-3">{message}</div>
              )}
              {error && <div className="alert alert-danger mt-3">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
